export const subscriptionEn = {
  aiPlanRequired:
    'AI planning requires a subscription. Please upgrade to access this feature.',
  placesImagesRequired: 'Places images require a subscription. Please upgrade to access this feature.',
  upgradeCta: 'Upgrade',
  trialActive: (days: number) =>
    days === 1 ? '1 day left in your free trial' : `${days} days left in your free trial`,
  trialExpired: 'Your free trial has ended.',
  tierLabel: {
    free: 'Free',
    basic: 'Basic',
    premium: 'Premium',
  },
} as const;
